import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "input-form horizontal" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-box width-auto" }
const _hoisted_4 = { class: "input-box" }
const _hoisted_5 = { class: "input-row" }
const _hoisted_6 = { class: "input-box" }
const _hoisted_7 = { class: "input-label" }
const _hoisted_8 = {
  key: 1,
  class: "sms-btn disabled"
}

import { ref, inject, reactive, computed, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n'
import { useUserStore } from '@/store';
import PopupForm from '@/components/PopupForm.vue';
import { bindAccountOTP, bindAccount } from '@/api';


export default {
  __name: 'BindMobile',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const MyToast = inject('myToast')

const { t } = useI18n()
const userStore = useUserStore()

const form = reactive({
  phone: '',
  verifyCode: '',
})
const coldDownTime = ref(0);
const coldDownInterval = ref(null);

const smsDisabled = computed(() => {
  return form.phone.length < 10;
})

const bindDisabled = computed(() => {
  return form.phone.length < 10 || form.verifyCode.length < 6;
})

onUnmounted(() => {
  if(coldDownInterval.value) {
    clearInterval(coldDownInterval.value);
  }
})

const coldDown = () => {
  if (coldDownInterval.value) {
    clearInterval(coldDownInterval.value);
  }
  coldDownInterval.value = setInterval(() => {
    coldDownTime.value = coldDownTime.value - 1;
    if (coldDownTime.value === 0) {
      clearInterval(coldDownInterval.value);
    }
  }, 1000)
}

const sendVerifyCode = () => {
  if (smsDisabled.value) {
    return false;
  }
  bindAccountOTP({
    phone: form.phone,
    areaCode: '63',
  }).then(res => {
    coldDownTime.value = 60;
    coldDown();
  });
}

const doBind = () => {
  bindAccount({
    phone: form.phone,
    areaCode: '63',
    verifyCode: form.verifyCode,
  }).then(res => {
    MyToast({ type: 'success', message: t('notify.operateSuccess') });
    emit('onClose');
    userStore.loadUserInfo();
  });
}

const inputBlur = (e) => {
  let field = e.target.name
  if (field) {
    form[field] = form[field].replace(/ +/g, '');
  }
}

return (_ctx, _cache) => {
  const _component_van_field = _resolveComponent("van-field")
  const _component_van_button = _resolveComponent("van-button")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createBlock(PopupForm, {
    title: _ctx.$t('user.bindMobile'),
    onOnClose: _cache[2] || (_cache[2] = $event => (emit('onClose')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_field, {
              "model-value": "+63",
              class: "input-prefix",
              readonly: ""
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_van_field, {
              modelValue: form.phone,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((form.phone) = $event)),
              name: "phone",
              class: "input-field",
              placeholder: _ctx.$t('placeholder.registerPhone'),
              type: "digit",
              onBlur: inputBlur,
              maxlength: "10",
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('label.otp')) + ":", 1),
            _createVNode(_component_van_field, {
              modelValue: form.verifyCode,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((form.verifyCode) = $event)),
              name: "verifyCode",
              class: "input-field",
              type: "digit",
              onBlur: inputBlur,
              maxlength: "6",
              clearable: ""
            }, null, 8, ["modelValue"]),
            (coldDownTime.value === 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(`sms-btn ${smsDisabled.value ? 'disabled' : ''}`),
                  onClick: sendVerifyCode
                }, _toDisplayString(_ctx.$t('common.send')), 3))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('common.smsColdDown')) + " " + _toDisplayString(coldDownTime.value) + _toDisplayString(_ctx.$t('common.second')), 1))
          ])
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_van_button, {
          class: "submit-btn",
          disabled: bindDisabled.value,
          onClick: doBind
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.confirm').toUpperCase()), 1)
          ]),
          _: 1
        }, 8, ["disabled"])), [
          [_directive_audio]
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

}